/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Grid as MuiGrid,
  Paper,
  TextField,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from '@material-ui/core';
import { AlertLocal } from '../components';
import { errorAlert, successAlert } from '../Shared/helpers';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
// import useCompany from '../hooks/useCompany';
import CalenderLocal from '../components/fields/CalenderLocal';
import { buildHrFormNote, parseHrFormNote } from '../common/hrFormNote';

const buildDefaultExtraInfo = (employee: any) => ({
  jobTitle: employee?.speciality || '',
  nationality: employee?.national || '',
  religion: '',
  address: employee?.address || '',
  supervisorName: '',
  contractPeriod: '',
  probationPeriod: '',
  vacationStart: '',
  vacationEnd: '',
  absenceDays: 0,
  absenceDeduction: 0,
});

const toNumber = (value: any) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const round2 = (value: number) => {
  return Math.round((value + Number.EPSILON) * 100) / 100;
};

const getSuggestedAbsenceDays = (returnDate: any) => {
  const dt = startOfDay(returnDate);
  if (!dt) return 0;
  return Math.max(dt.getDate() - 1, 0);
};

const getSuggestedAbsenceDeduction = ({
  employee,
  absenceDays,
  returnDate,
}: any) => {
  const days = Math.max(0, toNumber(absenceDays));
  if (!days) return 0;

  const dt = startOfDay(returnDate);
  if (!dt) return 0;

  const monthDays = new Date(dt.getFullYear(), dt.getMonth() + 1, 0).getDate();
  if (!monthDays) return 0;

  const monthlySalary =
    toNumber(employee?.basicSalary) + toNumber(employee?.extraSalary);
  if (!monthlySalary) return 0;

  const dailyRate = monthlySalary / monthDays;
  return round2(dailyRate * days);
};

const startOfDay = (value: any) => {
  const dt = new Date(value || new Date());
  if (Number.isNaN(dt.getTime())) {
    return null;
  }
  dt.setHours(0, 0, 0, 0);
  return dt;
};

const endOfDay = (value: any) => {
  const dt = new Date(value || new Date());
  if (Number.isNaN(dt.getTime())) {
    return null;
  }
  dt.setHours(23, 59, 59, 999);
  return dt;
};

const detectModeFromRow = (row: any) => {
  const rowTitle = `${row?.title || ''}`.toLowerCase();
  if (
    row?.isVacation ||
    rowTitle.includes('vacation') ||
    rowTitle.includes('اجاز')
  ) {
    return 'return';
  }
  return 'new';
};

const PopupStartWork = ({
  open,
  onClose,
  addAction,
  editAction,
  employees,
  company,
  theme,
  isRTL,
  words,
  onRefresh,
  row,
  isNew,
}: any) => {
  const [selectedEmployee, setSelectedEmployee] = useState<any>(null);
  const [enrollmentDate, setEnrollmentDate] = useState<Date>(new Date());
  const [enrollmentDesc, setEnrollmentDesc] = useState('');
  const [formMode, setFormMode] = useState<'new' | 'return'>('new');
  const [extraInfo, setExtraInfo] = useState<any>(buildDefaultExtraInfo(null));
  const [alrt, setAlrt] = useState({ show: false, msg: '', type: undefined });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      if (!isNew && row) {
        const foundEmployee = (employees || []).find(
          (emp: any) => emp._id === row.employeeId,
        );
        const parsed = parseHrFormNote(row?.note);
        const mode =
          parsed?.kind === 'startWork' && parsed?.mode
            ? parsed.mode
            : detectModeFromRow(row);

        // Populate form for editing
        setSelectedEmployee(
          foundEmployee || {
            _id: row.employeeId,
            name: row.employeeName,
            nameAr: row.employeeNameAr,
          },
        );
        setEnrollmentDate(new Date(row.time));
        setEnrollmentDesc(parsed?.notes || row.desc || '');
        setFormMode(mode === 'return' ? 'return' : 'new');
        const parsedExtra = parsed?.extra || {};
        const fallbackVacationStart = foundEmployee?.vacationStart || '';
        const fallbackVacationEnd = foundEmployee?.vacationEnd || '';
        setExtraInfo({
          ...buildDefaultExtraInfo(foundEmployee),
          ...parsedExtra,
          vacationStart:
            parsedExtra?.vacationStart ||
            row?.vacationStart ||
            fallbackVacationStart,
          vacationEnd:
            parsedExtra?.vacationEnd || row?.vacationEnd || fallbackVacationEnd,
          absenceDays:
            parsedExtra?.absenceDays ??
            row?.isAbsent ??
            buildDefaultExtraInfo(foundEmployee).absenceDays,
          absenceDeduction:
            parsedExtra?.absenceDeduction ??
            row?.deduction ??
            buildDefaultExtraInfo(foundEmployee).absenceDeduction,
        });
      } else {
        resetForm();
      }
    }
  }, [open, row, isNew]);

  useEffect(() => {
    if (formMode !== 'return' || !selectedEmployee) {
      return;
    }

    setExtraInfo((prev: any) => {
      const vacationStart =
        prev?.vacationStart || selectedEmployee?.vacationStart || '';
      const vacationEnd =
        prev?.vacationEnd || selectedEmployee?.vacationEnd || '';
      const currentAbsenceDays = toNumber(prev?.absenceDays);
      const suggestedAbsenceDays =
        currentAbsenceDays > 0
          ? currentAbsenceDays
          : getSuggestedAbsenceDays(enrollmentDate);

      const currentAbsenceDeduction = toNumber(prev?.absenceDeduction);
      const suggestedAbsenceDeduction =
        currentAbsenceDeduction > 0
          ? currentAbsenceDeduction
          : getSuggestedAbsenceDeduction({
              employee: selectedEmployee,
              absenceDays: suggestedAbsenceDays,
              returnDate: enrollmentDate,
            });

      if (
        vacationStart === prev?.vacationStart &&
        vacationEnd === prev?.vacationEnd &&
        suggestedAbsenceDays === toNumber(prev?.absenceDays) &&
        suggestedAbsenceDeduction === toNumber(prev?.absenceDeduction)
      ) {
        return prev;
      }

      return {
        ...prev,
        vacationStart,
        vacationEnd,
        absenceDays: suggestedAbsenceDays,
        absenceDeduction: suggestedAbsenceDeduction,
      };
    });
  }, [formMode, selectedEmployee, enrollmentDate]);

  const handleStartWork = async () => {
    if (!selectedEmployee) {
      errorAlert(setAlrt, isRTL);
      return;
    }

    const vacationStart =
      formMode === 'return' && extraInfo?.vacationStart
        ? startOfDay(extraInfo.vacationStart)
        : null;
    const vacationEnd =
      formMode === 'return' && extraInfo?.vacationEnd
        ? endOfDay(extraInfo.vacationEnd)
        : null;
    const absenceDays =
      formMode === 'return' ? Math.max(0, toNumber(extraInfo?.absenceDays)) : 0;
    const suggestedAbsenceDeduction =
      formMode === 'return'
        ? getSuggestedAbsenceDeduction({
            employee: selectedEmployee,
            absenceDays,
            returnDate: enrollmentDate,
          })
        : 0;
    const absenceDeduction =
      formMode === 'return'
        ? Math.max(
            0,
            toNumber(extraInfo?.absenceDeduction) || suggestedAbsenceDeduction,
          )
        : 0;

    if (
      formMode === 'return' &&
      (!vacationStart || !vacationEnd || vacationEnd < vacationStart)
    ) {
      errorAlert(setAlrt, isRTL);
      return;
    }

    const normalizedExtra = {
      ...extraInfo,
      vacationStart:
        formMode === 'return' && vacationStart
          ? vacationStart.toISOString()
          : '',
      vacationEnd:
        formMode === 'return' && vacationEnd ? vacationEnd.toISOString() : '',
      absenceDays,
      absenceDeduction,
    };

    setSaving(true);
    try {
      const modeTitle =
        formMode === 'return'
          ? isRTL
            ? 'مباشرة بعد اجازة'
            : 'Return From Vacation'
          : isRTL
            ? 'مباشرة عمل جديد'
            : 'Start Work - New Employee';

      const note = buildHrFormNote({
        kind: 'startWork',
        mode: formMode,
        notes: enrollmentDesc,
        extra: normalizedExtra,
      });

      const variables = {
        ...(isNew ? {} : { _id: row?._id }),
        time: enrollmentDate,
        title: modeTitle,
        desc: enrollmentDesc,
        contract: {
          contractId: '',
          contractName: '',
          contractNameAr: '',
        },
        department: {
          departmentId: selectedEmployee?.departmentId || '',
          departmentName: selectedEmployee?.departmentName || '',
          departmentNameAr: selectedEmployee?.departmentNameAr || '',
          departmentColor: selectedEmployee?.departmentColor || '',
        },
        employee: {
          employeeId: selectedEmployee._id,
          employeeName: selectedEmployee.name,
          employeeNameAr: selectedEmployee.nameAr,
        },
        bonos: 0,
        overtime: 0,
        deduction: absenceDeduction,
        isWorking: 1,
        isAbsent: absenceDays,
        isShift1: 0,
        isShift2: 0,
        isVacation: formMode === 'return',
        note,
      };

      const mutate = isNew ? addAction : editAction;
      const mutateName = isNew ? 'createStartWork' : 'updateStartWork';
      const res = await mutate({ variables });

      if (res?.data?.[mutateName]?.ok) {
        successAlert(setAlrt, isRTL);
        if (onRefresh) {
          onRefresh();
        }
        onClose();
        resetForm();
      }
    } catch (error) {
      console.log(error);
      errorAlert(setAlrt, isRTL);
    }
    setSaving(false);
  };

  const resetForm = () => {
    setSelectedEmployee(null);
    setEnrollmentDate(new Date());
    setEnrollmentDesc('');
    setFormMode('new');
    setExtraInfo(buildDefaultExtraInfo(null));
    setAlrt({ show: false, msg: '', type: undefined });
  };

  if (!open) return null;

  return (
    <Box
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <Paper
        elevation={3}
        style={{
          padding: 30,
          maxWidth: 600,
          width: '90%',
          maxHeight: '90vh',
          overflow: 'auto',
          borderRadius: 15,
        }}
      >
        <Typography
          variant="h5"
          style={{
            color: theme?.palette?.primary?.main,
            fontWeight: 'bold',
            marginBottom: 30,
            textAlign: 'center',
          }}
        >
          {isRTL
            ? 'نموذج مباشرة العمل - إضافة موظف لقائمة الرواتب'
            : 'Start Work Form - Enroll Employee to Salary'}
        </Typography>

        <MuiGrid container spacing={3}>
          <MuiGrid item xs={12}>
            <FormControl component="fieldset">
              <FormLabel component="legend">
                {isRTL ? 'نوع النموذج' : 'Form Type'}
              </FormLabel>
              <RadioGroup
                row
                value={formMode}
                onChange={(e: any) => setFormMode(e.target.value)}
              >
                <FormControlLabel
                  value="new"
                  control={<Radio color="primary" />}
                  label={isRTL ? 'مباشرة جديدة' : 'New Join'}
                />
                <FormControlLabel
                  value="return"
                  control={<Radio color="primary" />}
                  label={isRTL ? 'عودة من اجازة' : 'Return From Vacation'}
                />
              </RadioGroup>
            </FormControl>
          </MuiGrid>

          {/* Employee Selection */}
          <MuiGrid item xs={12}>
            <TextField
              select
              fullWidth
              variant="outlined"
              label={isRTL ? 'الموظف' : 'Employee'}
              value={selectedEmployee?._id || ''}
              onChange={(e: any) => {
                const employee = (employees || []).find(
                  (emp: any) => emp._id === e.target.value,
                );
                setSelectedEmployee(employee || null);
              }}
              SelectProps={{ native: true }}
            >
              <option value="">
                {isRTL ? 'اختر الموظف' : 'Select employee'}
              </option>
              {(employees || []).map((emp: any) => (
                <option key={emp._id} value={emp._id}>
                  {isRTL ? emp.nameAr || emp.name : emp.name || emp.nameAr}
                </option>
              ))}
            </TextField>
          </MuiGrid>

          {/* Enrollment Date */}
          <MuiGrid item xs={12}>
            <CalenderLocal
              label={
                formMode === 'return'
                  ? isRTL
                    ? 'تاريخ المباشرة بعد الاجازة'
                    : 'Return Date'
                  : isRTL
                    ? 'تاريخ مباشرة العمل'
                    : 'Enrollment Date'
              }
              value={enrollmentDate}
              onChange={(date: any) => setEnrollmentDate(date)}
              format="dd/MM/yyyy"
              isRTL={isRTL}
            />
          </MuiGrid>

          {formMode === 'return' && (
            <>
              <MuiGrid item xs={12} md={6}>
                <CalenderLocal
                  label={isRTL ? 'تاريخ بداية الاجازة' : 'Vacation Start Date'}
                  value={extraInfo?.vacationStart || null}
                  onChange={(date: any) =>
                    setExtraInfo((prev: any) => ({
                      ...prev,
                      vacationStart: date ? startOfDay(date) : '',
                    }))
                  }
                  format="dd/MM/yyyy"
                  isRTL={isRTL}
                />
              </MuiGrid>
              <MuiGrid item xs={12} md={6}>
                <CalenderLocal
                  label={isRTL ? 'تاريخ نهاية الاجازة' : 'Vacation End Date'}
                  value={extraInfo?.vacationEnd || null}
                  onChange={(date: any) =>
                    setExtraInfo((prev: any) => ({
                      ...prev,
                      vacationEnd: date ? endOfDay(date) : '',
                    }))
                  }
                  format="dd/MM/yyyy"
                  isRTL={isRTL}
                />
              </MuiGrid>
              <MuiGrid item xs={12} md={6}>
                <TextField
                  fullWidth
                  type="number"
                  variant="outlined"
                  label={isRTL ? 'ايام الغياب من الشهر' : 'Absent Days'}
                  value={extraInfo?.absenceDays || 0}
                  onChange={(e: any) => {
                    const absenceDays = Math.max(0, toNumber(e.target.value));
                    const absenceDeduction = getSuggestedAbsenceDeduction({
                      employee: selectedEmployee,
                      absenceDays,
                      returnDate: enrollmentDate,
                    });
                    setExtraInfo((prev: any) => ({
                      ...prev,
                      absenceDays,
                      absenceDeduction,
                    }));
                  }}
                  onFocus={(e) => e.target.select()}
                />
              </MuiGrid>
              <MuiGrid item xs={12} md={6}>
                <TextField
                  fullWidth
                  type="number"
                  variant="outlined"
                  label={isRTL ? 'قيمة خصم الغياب' : 'Absence Deduction'}
                  value={extraInfo?.absenceDeduction || 0}
                  onChange={(e: any) => {
                    const absenceDeduction = Math.max(
                      0,
                      toNumber(e.target.value),
                    );
                    setExtraInfo((prev: any) => ({
                      ...prev,
                      absenceDeduction,
                    }));
                  }}
                  onFocus={(e) => e.target.select()}
                />
              </MuiGrid>
            </>
          )}

          {/* Employee Info Display */}
          {selectedEmployee && (
            <>
              <MuiGrid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label={isRTL ? 'رقم الهاتف' : 'Phone'}
                  value={selectedEmployee?.phone || ''}
                  disabled
                  variant="outlined"
                />
              </MuiGrid>
              <MuiGrid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label={isRTL ? 'الراتب الاساسي' : 'Basic Salary'}
                  value={selectedEmployee?.basicSalary?.toLocaleString() || '0'}
                  disabled
                  variant="outlined"
                />
              </MuiGrid>
              <MuiGrid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label={isRTL ? 'البدلات' : 'Allowances'}
                  value={selectedEmployee?.extraSalary?.toLocaleString() || '0'}
                  disabled
                  variant="outlined"
                />
              </MuiGrid>
            </>
          )}

          {/* Description/Notes */}
          <MuiGrid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={4}
              variant="outlined"
              label={isRTL ? 'ملاحظات' : 'Notes'}
              value={enrollmentDesc}
              onChange={(e) => setEnrollmentDesc(e.target.value)}
            />
          </MuiGrid>

          <MuiGrid item xs={12} md={6}>
            <TextField
              fullWidth
              variant="outlined"
              label={isRTL ? 'المسمى الوظيفي' : 'Job Title'}
              value={extraInfo?.jobTitle || ''}
              onChange={(e) =>
                setExtraInfo((prev: any) => ({
                  ...prev,
                  jobTitle: e.target.value,
                }))
              }
            />
          </MuiGrid>
          <MuiGrid item xs={12} md={6}>
            <TextField
              fullWidth
              variant="outlined"
              label={isRTL ? 'الجنسية' : 'Nationality'}
              value={extraInfo?.nationality || ''}
              onChange={(e) =>
                setExtraInfo((prev: any) => ({
                  ...prev,
                  nationality: e.target.value,
                }))
              }
            />
          </MuiGrid>
          <MuiGrid item xs={12} md={6}>
            <TextField
              fullWidth
              variant="outlined"
              label={isRTL ? 'الديانة' : 'Religion'}
              value={extraInfo?.religion || ''}
              onChange={(e) =>
                setExtraInfo((prev: any) => ({
                  ...prev,
                  religion: e.target.value,
                }))
              }
            />
          </MuiGrid>
          <MuiGrid item xs={12} md={6}>
            <TextField
              fullWidth
              variant="outlined"
              label={isRTL ? 'اسم المشرف' : 'Supervisor Name'}
              value={extraInfo?.supervisorName || ''}
              onChange={(e) =>
                setExtraInfo((prev: any) => ({
                  ...prev,
                  supervisorName: e.target.value,
                }))
              }
            />
          </MuiGrid>
          <MuiGrid item xs={12} md={6}>
            <TextField
              fullWidth
              variant="outlined"
              label={isRTL ? 'مدة العقد' : 'Contract Period'}
              value={extraInfo?.contractPeriod || ''}
              onChange={(e) =>
                setExtraInfo((prev: any) => ({
                  ...prev,
                  contractPeriod: e.target.value,
                }))
              }
            />
          </MuiGrid>
          <MuiGrid item xs={12} md={6}>
            <TextField
              fullWidth
              variant="outlined"
              label={isRTL ? 'فترة التجربة' : 'Probation Period'}
              value={extraInfo?.probationPeriod || ''}
              onChange={(e) =>
                setExtraInfo((prev: any) => ({
                  ...prev,
                  probationPeriod: e.target.value,
                }))
              }
            />
          </MuiGrid>
          <MuiGrid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={2}
              variant="outlined"
              label={isRTL ? 'العنوان' : 'Address'}
              value={extraInfo?.address || ''}
              onChange={(e) =>
                setExtraInfo((prev: any) => ({
                  ...prev,
                  address: e.target.value,
                }))
              }
            />
          </MuiGrid>

          {/* Action Buttons */}
          <MuiGrid item xs={12}>
            <Box
              display="flex"
              justifyContent="center"
              style={{ gap: 16, marginTop: 20 }}
            >
              <Button
                variant="contained"
                color="primary"
                size="large"
                startIcon={<PlayArrowIcon />}
                onClick={handleStartWork}
                disabled={!selectedEmployee || saving}
                style={{ minWidth: 180 }}
              >
                {saving
                  ? isRTL
                    ? 'جاري الحفظ...'
                    : 'Saving...'
                  : isRTL
                    ? 'مباشرة العمل'
                    : 'Start Work'}
              </Button>
              <Button
                variant="outlined"
                size="large"
                onClick={onClose}
                style={{ minWidth: 120 }}
              >
                {isRTL ? 'إلغاء' : 'Cancel'}
              </Button>
            </Box>
          </MuiGrid>
        </MuiGrid>

        {alrt.show && (
          <AlertLocal
            isRTL={isRTL}
            type={alrt?.type}
            msg={alrt?.msg}
            top={-100}
          />
        )}
      </Paper>
    </Box>
  );
};

export default PopupStartWork;
